webpackJsonp([78],{

/***/ 1234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RouteTransition.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RouteTransition = ({
  name: 'RouteTransition'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13dd5c14","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RouteTransition.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in","enter-active-class":"animated fadeIn fast","leave-active-class":"animated fadeOut fast"}},[_vm._t("default")],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./src/components/RouteTransition.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  RouteTransition,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_RouteTransition = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1411);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("313f86d6", content, true, {});

/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, "select.ag-filter-select{display:none}input.ag-filter-filter{margin-top:8px;padding-top:5px}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/App.vue"],"names":[],"mappings":"AACA,wBACI,YAAa,CAChB,AAKD,uBACI,eAAe,AACf,eAAgB,CACnB","file":"App.vue","sourcesContent":["\nselect.ag-filter-select{\n    display:none;\n}\n/*  div.ag-menu{\n    margin-left: -11%;\n  }\n*/\ninput.ag-filter-filter{\n    margin-top:8px;\n    padding-top:5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1412:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1413);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("4682d6eb", content, true, {});

/***/ }),

/***/ 1413:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(614);
exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".divider[data-v-492114f2]{-webkit-box-flex:0;flex:none}.sys_admin.role[data-v-492114f2]{color:red;background-color:green}.circuit-background[data-v-492114f2]{background:url(" + escape(__webpack_require__(975)) + ");background-position:0 -35px;height:32px;max-height:32px;width:100%}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/App.vue"],"names":[],"mappings":"AACA,0BACE,mBAAoB,AACZ,SAAW,CACpB,AACD,iCACE,UAAW,AACX,sBAAwB,CACzB,AACD,qCACE,yCAA6D,AAC7D,4BAA6B,AAC7B,YAAa,AACb,gBAAiB,AACjB,UAAY,CACb","file":"App.vue","sourcesContent":["\n.divider[data-v-492114f2] {\n  -webkit-box-flex: 0;\n          flex: none;\n}\n.sys_admin.role[data-v-492114f2] {\n  color: red;\n  background-color: green;\n}\n.circuit-background[data-v-492114f2] {\n  background: url('./assets/img/circuit-board-background.png');\n  background-position: 0 -35px;\n  height: 32px;\n  max-height: 32px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports["vue-sticky"]=e():t["vue-sticky"]=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var o=n[i]={exports:{},id:i,loaded:!1};return t[i].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),n(4),e.default={props:{top:{type:[String],default:"auto"},zIndex:{type:Number,default:10}},data:function(){return{child:null,stickyHeight:0,parsedTop:parseFloat(this.top,10),position:"static"}},watch:{position:function(t){switch(this.child.style.position=t,t){case"sticky":this.child.style.position="fixed",this.child.style.top=this.top;break;case"absolute":this.child.style.position="absolute",this.child.style.top="auto",this.child.style.bottom="0";break;case"static":default:this.child.style.position="static"}}},methods:{scrollHandler:function(){var t=this.$el.getBoundingClientRect(),e=this.$el.parentElement.getBoundingClientRect(),n=t.top>this.parsedTop,i=e.bottom<this.parsedTop+this.stickyHeight;n?this.position="static":i?this.position="absolute":this.position="sticky"}},render:function(t){return t("div",{class:"sticky",style:{top:this.top,bottom:this.bottom,zIndex:this.zIndex}},[this.$slots.default,t("div",{style:{clear:"both",height:"1px"}},[])])},mounted:function(){var t=this;this.$nextTick(function(){var e=window.getComputedStyle(t.$el),n=e.position,i=n.indexOf("sticky")>-1,o=t.$el.firstElementChild;!i&&o&&(t.child=o,o.style.zIndex=t.zIndex,t.stickyHeight=parseFloat(e.height,10),t.$el.style.position="static",t.$el.style.height=e.height,window.addEventListener("scroll",t.scrollHandler,!0),t.scrollHandler())})}}},function(t,e,n){e=t.exports=n(2)(),e.push([t.id,".sticky{position:-webkit-sticky;position:sticky}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var i={},o=0;o<this.length;o++){var s=this[o][0];"number"==typeof s&&(i[s]=!0)}for(o=0;o<e.length;o++){var r=e[o];"number"==typeof r[0]&&i[r[0]]||(n&&!r[2]?r[2]=n:n&&(r[2]="("+r[2]+") and ("+n+")"),t.push(r))}},t}},function(t,e,n){function i(t,e){for(var n=0;n<t.length;n++){var i=t[n],o=d[i.id];if(o){o.refs++;for(var s=0;s<o.parts.length;s++)o.parts[s](i.parts[s]);for(;s<i.parts.length;s++)o.parts.push(c(i.parts[s],e))}else{for(var r=[],s=0;s<i.parts.length;s++)r.push(c(i.parts[s],e));d[i.id]={id:i.id,refs:1,parts:r}}}}function o(t){for(var e=[],n={},i=0;i<t.length;i++){var o=t[i],s=o[0],r=o[1],a=o[2],l=o[3],c={css:r,media:a,sourceMap:l};n[s]?n[s].parts.push(c):e.push(n[s]={id:s,parts:[c]})}return e}function s(t,e){var n=y(),i=g[g.length-1];if("top"===t.insertAt)i?i.nextSibling?n.insertBefore(e,i.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),g.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function r(t){t.parentNode.removeChild(t);var e=g.indexOf(t);e>=0&&g.splice(e,1)}function a(t){var e=document.createElement("style");return e.type="text/css",s(t,e),e}function l(t){var e=document.createElement("link");return e.rel="stylesheet",s(t,e),e}function c(t,e){var n,i,o;if(e.singleton){var s=b++;n=m||(m=a(e)),i=u.bind(null,n,s,!1),o=u.bind(null,n,s,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=l(e),i=f.bind(null,n),o=function(){r(n),n.href&&URL.revokeObjectURL(n.href)}):(n=a(e),i=p.bind(null,n),o=function(){r(n)});return i(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;i(t=e)}else o()}}function u(t,e,n,i){var o=n?"":i.css;if(t.styleSheet)t.styleSheet.cssText=x(e,o);else{var s=document.createTextNode(o),r=t.childNodes;r[e]&&t.removeChild(r[e]),r.length?t.insertBefore(s,r[e]):t.appendChild(s)}}function p(t,e){var n=e.css,i=e.media;if(i&&t.setAttribute("media",i),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function f(t,e){var n=e.css,i=e.sourceMap;i&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */");var o=new Blob([n],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(o),s&&URL.revokeObjectURL(s)}var d={},h=function(t){var e;return function(){return"undefined"==typeof e&&(e=t.apply(this,arguments)),e}},v=h(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),y=h(function(){return document.head||document.getElementsByTagName("head")[0]}),m=null,b=0,g=[];t.exports=function(t,e){e=e||{},"undefined"==typeof e.singleton&&(e.singleton=v()),"undefined"==typeof e.insertAt&&(e.insertAt="bottom");var n=o(t);return i(n,e),function(t){for(var s=[],r=0;r<n.length;r++){var a=n[r],l=d[a.id];l.refs--,s.push(l)}if(t){var c=o(t);i(c,e)}for(var r=0;r<s.length;r++){var l=s[r];if(0===l.refs){for(var u=0;u<l.parts.length;u++)l.parts[u]();delete d[l.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e,n){var i=n(1);"string"==typeof i&&(i=[[t.id,i,""]]);n(3)(i,{});i.locals&&(t.exports=i.locals)}])});

/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1416);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("bd79e8ec", content, true, {});

/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(614);
exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".sys_admin.role[data-v-6591cfe0]{color:red}.circuit-background[data-v-6591cfe0]{background:url(" + escape(__webpack_require__(975)) + ");background-position:0 -35px;height:12px;width:100%}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/Topbar.vue"],"names":[],"mappings":"AACA,iCACE,SAAW,CACZ,AACD,qCACE,yCAA8D,AAC9D,4BAA6B,AAC7B,YAAa,AACb,UAAY,CACb","file":"Topbar.vue","sourcesContent":["\n.sys_admin.role[data-v-6591cfe0] {\n  color: red;\n}\n.circuit-background[data-v-6591cfe0] {\n  background: url('../assets/img/circuit-board-background.png');\n  background-position: 0 -35px;\n  height: 12px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1418);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("f2689c80", content, true, {});

/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, "p[data-v-4a83dc99]{margin:0}.no-results[data-v-4a83dc99]{padding:4px 16px}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/Search.vue"],"names":[],"mappings":"AACA,mBACE,QAAU,CACX,AACD,6BACE,gBAAkB,CACnB","file":"Search.vue","sourcesContent":["\np[data-v-4a83dc99] {\n  margin: 0;\n}\n.no-results[data-v-4a83dc99] {\n  padding: 4px 16px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1420);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("3511f3b6", content, true, {});

/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".search-input{min-width:320px;margin-bottom:3px}.search-input .input-group__details{min-height:0}.search-input .input-group__prepend-icon{-webkit-box-pack:center!important;justify-content:center!important;margin-top:3px}.result-link{padding:4px 16px}.result-link.selected-result,.result-link:active,.result-link:focus,.result-link:hover{background:#f8f9f9;outlined:0}@media only screen and (min-width:1100px){.search-input{min-width:440px}}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/Search.vue"],"names":[],"mappings":"AACA,cACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,oCACE,YAAc,CACf,AACD,yCACE,kCAAoC,AAC5B,iCAAmC,AAC3C,cAAgB,CACjB,AACD,aACE,gBAAkB,CACnB,AACD,uFAIE,mBAAoB,AACpB,UAAY,CACb,AACD,0CACA,cACI,eAAiB,CACpB,CACA","file":"Search.vue","sourcesContent":["\n.search-input {\n  min-width: 320px;\n  margin-bottom: 3px;\n}\n.search-input .input-group__details {\n  min-height: 0;\n}\n.search-input .input-group__prepend-icon {\n  -webkit-box-pack: center !important;\n          justify-content: center !important;\n  margin-top: 3px;\n}\n.result-link {\n  padding: 4px 16px;\n}\n.result-link.selected-result,\n.result-link:hover,\n.result-link:focus,\n.result-link:active {\n  background: #f8f9f9;\n  outlined: 0;\n}\n@media only screen and (min-width: 1100px) {\n.search-input {\n    min-width: 440px;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (fn, wait, opts) {
	if (!Number.isFinite(wait)) {
		throw new TypeError('Expected `wait` to be a finite number');
	}

	opts = opts || {};

	var leadingVal = void 0;
	var timer = void 0;
	var resolveList = [];

	return function () {
		var ctx = this;
		var args = arguments;

		return new Promise(function (resolve) {
			var runImmediately = opts.leading && !timer;

			clearTimeout(timer);

			timer = setTimeout(function () {
				timer = null;

				var res = opts.leading ? leadingVal : fn.apply(ctx, args);

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = resolveList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						resolve = _step.value;

						resolve(res);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				resolveList = [];
			}, wait);

			if (runImmediately) {
				leadingVal = fn.apply(ctx, args);
				resolve(leadingVal);
			} else {
				resolveList.push(resolve);
			}
		});
	};
};

/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Port of lower_bound from http://en.cppreference.com/w/cpp/algorithm/lower_bound
// Used to compute insertion index to keep queue sorted after insertion

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lowerBound(array, value, comp) {
	var first = 0;
	var count = array.length;

	while (count > 0) {
		var step = count / 2 | 0;
		var it = first + step;

		if (comp(array[it], value) <= 0) {
			first = ++it;
			count -= step + 1;
		} else {
			count = step;
		}
	}

	return first;
}

var PriorityQueue = function () {
	function PriorityQueue() {
		_classCallCheck(this, PriorityQueue);

		this._queue = [];
	}

	_createClass(PriorityQueue, [{
		key: 'enqueue',
		value: function enqueue(run, opts) {
			opts = Object.assign({
				priority: 0
			}, opts);

			var element = { priority: opts.priority, run: run };

			if (this.size && this._queue[this.size - 1].priority >= opts.priority) {
				this._queue.push(element);
				return;
			}

			var index = lowerBound(this._queue, element, function (a, b) {
				return b.priority - a.priority;
			});
			this._queue.splice(index, 0, element);
		}
	}, {
		key: 'dequeue',
		value: function dequeue() {
			return this._queue.shift().run;
		}
	}, {
		key: 'size',
		get: function get() {
			return this._queue.length;
		}
	}]);

	return PriorityQueue;
}();

var PQueue = function () {
	function PQueue(opts) {
		_classCallCheck(this, PQueue);

		opts = Object.assign({
			concurrency: Infinity,
			autoStart: true,
			queueClass: PriorityQueue
		}, opts);

		if (!(typeof opts.concurrency === 'number' && opts.concurrency >= 1)) {
			throw new TypeError('Expected `concurrency` to be a number from 1 and up, got `' + opts.concurrency + '` (' + _typeof(opts.concurrency) + ')');
		}

		this.queue = new opts.queueClass(); // eslint-disable-line new-cap
		this._queueClass = opts.queueClass;
		this._pendingCount = 0;
		this._concurrency = opts.concurrency;
		this._isPaused = opts.autoStart === false;
		this._resolveEmpty = function () {};
		this._resolveIdle = function () {};
	}

	_createClass(PQueue, [{
		key: '_next',
		value: function _next() {
			this._pendingCount--;

			if (this.queue.size > 0) {
				if (!this._isPaused) {
					this.queue.dequeue()();
				}
			} else {
				this._resolveEmpty();
				this._resolveEmpty = function () {};

				if (this._pendingCount === 0) {
					this._resolveIdle();
					this._resolveIdle = function () {};
				}
			}
		}
	}, {
		key: 'add',
		value: function add(fn, opts) {
			var _this = this;

			return new Promise(function (resolve, reject) {
				var run = function run() {
					_this._pendingCount++;

					try {
						Promise.resolve(fn()).then(function (val) {
							resolve(val);
							_this._next();
						}, function (err) {
							reject(err);
							_this._next();
						});
					} catch (err) {
						reject(err);
						_this._next();
					}
				};

				if (!_this._isPaused && _this._pendingCount < _this._concurrency) {
					run();
				} else {
					_this.queue.enqueue(run, opts);
				}
			});
		}
	}, {
		key: 'addAll',
		value: function addAll(fns, opts) {
			var _this2 = this;

			return Promise.all(fns.map(function (fn) {
				return _this2.add(fn, opts);
			}));
		}
	}, {
		key: 'start',
		value: function start() {
			if (!this._isPaused) {
				return;
			}

			this._isPaused = false;
			while (this.queue.size > 0 && this._pendingCount < this._concurrency) {
				this.queue.dequeue()();
			}
		}
	}, {
		key: 'pause',
		value: function pause() {
			this._isPaused = true;
		}
	}, {
		key: 'clear',
		value: function clear() {
			this.queue = new this._queueClass(); // eslint-disable-line new-cap
		}
	}, {
		key: 'onEmpty',
		value: function onEmpty() {
			var _this3 = this;

			// Instantly resolve if the queue is empty
			if (this.queue.size === 0) {
				return Promise.resolve();
			}

			return new Promise(function (resolve) {
				var existingResolve = _this3._resolveEmpty;
				_this3._resolveEmpty = function () {
					existingResolve();
					resolve();
				};
			});
		}
	}, {
		key: 'onIdle',
		value: function onIdle() {
			var _this4 = this;

			// Instantly resolve if none pending
			if (this._pendingCount === 0) {
				return Promise.resolve();
			}

			return new Promise(function (resolve) {
				var existingResolve = _this4._resolveIdle;
				_this4._resolveIdle = function () {
					existingResolve();
					resolve();
				};
			});
		}
	}, {
		key: 'size',
		get: function get() {
			return this.queue.size;
		}
	}, {
		key: 'pending',
		get: function get() {
			return this._pendingCount;
		}
	}, {
		key: 'isPaused',
		get: function get() {
			return this._isPaused;
		}
	}]);

	return PQueue;
}();

module.exports = PQueue;

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1424);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("10efe50d", content, true, {});

/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".navigation-drawer>.list .list__tile--active[data-v-4f365a6e]{color:#0072ce;background-color:#ecedef;border-right:1px solid #dee1e3;font-weight:700}.toolbar[data-v-4f365a6e]{height:55px!important}.btn[data-v-4f365a6e]{min-width:10px}.container[data-v-4f365a6e]{padding-top:12px;padding-bottom:12px}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/SlideSidebarMenu.vue"],"names":[],"mappings":"AACA,8DACE,cAAe,AACf,yBAA0B,AAC1B,+BAAgC,AAChC,eAAkB,CACnB,AACD,0BACE,qBAAwB,CACzB,AACD,sBACE,cAAgB,CACjB,AACD,4BACE,iBAAkB,AAClB,mBAAqB,CACtB","file":"SlideSidebarMenu.vue","sourcesContent":["\n.navigation-drawer > .list .list__tile--active[data-v-4f365a6e] {\n  color: #0072ce;\n  background-color: #ecedef;\n  border-right: 1px solid #dee1e3;\n  font-weight: bold;\n}\n.toolbar[data-v-4f365a6e] {\n  height: 55px !important;\n}\n.btn[data-v-4f365a6e] {\n  min-width: 10px;\n}\n.container[data-v-4f365a6e] {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1426);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("1cd254ef", content, true, {});

/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".container[data-v-abdc7f96]{padding-top:12px;padding-bottom:12px}.close-btn[data-v-abdc7f96]{right:6px;top:2px;height:44px;width:44px;z-index:100}button[data-v-abdc7f96]{margin:0 -2px}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/TopbarMenu.vue"],"names":[],"mappings":"AACA,4BACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,4BACE,UAAW,AACX,QAAS,AACT,YAAa,AACb,WAAY,AACZ,WAAa,CACd,AACD,wBACE,aAAe,CAChB","file":"TopbarMenu.vue","sourcesContent":["\n.container[data-v-abdc7f96] {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.close-btn[data-v-abdc7f96] {\n  right: 6px;\n  top: 2px;\n  height: 44px;\n  width: 44px;\n  z-index: 100;\n}\nbutton[data-v-abdc7f96] {\n  margin: 0 -2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1428);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("5575a1c0", content, true, {});

/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".topbarmenu-list-override .list__tile{padding-left:16px;padding-right:16px}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/TopbarMenu.vue"],"names":[],"mappings":"AACA,sCACE,kBAAmB,AACnB,kBAAoB,CACrB","file":"TopbarMenu.vue","sourcesContent":["\n.topbarmenu-list-override .list__tile {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1430);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("2b562d41", content, true, {});

/***/ }),

/***/ 1430:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".menu-h-link.router-link-active .icon,.menu-h-link.router-link-active span{color:#0072ce}.menu-v-link>.list__tile{padding-left:14px}.menu-v-link.subMenu>.list__tile{height:40px}.navigation-drawer>.list .list__tile--active{color:#0072ce;background-color:#ecedef;border-right:1px solid #dee1e3;font-weight:700}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/MenuList.vue"],"names":[],"mappings":"AAIA,2EACE,aAAe,CAChB,AACD,yBACE,iBAAmB,CACpB,AACD,iCACE,WAAa,CACd,AAKD,6CACE,cAAe,AACf,yBAA0B,AAC1B,+BAAgC,AAChC,eAAkB,CACnB","file":"MenuList.vue","sourcesContent":["\n.menu-h-link.router-link-active span {\n  color: #0072ce;\n}\n.menu-h-link.router-link-active .icon {\n  color: #0072ce;\n}\n.menu-v-link > .list__tile {\n  padding-left: 14px;\n}\n.menu-v-link.subMenu > .list__tile {\n  height: 40px;\n}\n.list > .menu-v-link > .list__tile--active .icon {\n}\n.list > .menu-v-link > .list__tile--active .list__tile__title {\n}\n.navigation-drawer > .list .list__tile--active {\n  color: #0072ce;\n  background-color: #ecedef;\n  border-right: 1px solid #dee1e3;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1944:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue-sticky-position/dist/sticky.js
var sticky = __webpack_require__(1414);
var sticky_default = /*#__PURE__*/__webpack_require__.n(sticky);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LogoMultitech.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LogoMultitech = ({
  name: 'LogoMultitech',
  props: {
    white: Boolean
  },
  computed: {
    primary: function primary() {
      return this.white ? '#FFF' : '#0072CE';
    },
    secondary: function secondary() {
      return this.white ? '#FFF' : '#000';
    },
    innerRing: function innerRing() {
      return this.white ? '#000' : '#FFF';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2402b98e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoMultitech.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 324 61.92"}},[_c('title',[_vm._v("Product of MultiTech")]),_vm._v(" "),_c('path',{attrs:{"fill":_vm.primary,"d":"M1.89 14.62h9.57l7.8 12.65 7.8-12.65h9.56V47.3h-9V28.53l-8.34 12.8h-.19l-8.28-12.7V47.3H1.89zM57.16 47.9c-2.34 0-4.44-.29-6.3-.88a12.2 12.2 0 0 1-4.77-2.73 12.04 12.04 0 0 1-3.01-4.67c-.7-1.88-1.05-4.1-1.05-6.65V14.62h9.24v18.16c0 2.37.54 4.12 1.62 5.25a5.73 5.73 0 0 0 4.36 1.7c1.82 0 3.27-.54 4.35-1.63 1.08-1.09 1.62-2.78 1.62-5.09V14.62h9.25v18.11c0 2.65-.37 4.93-1.1 6.84s-1.76 3.49-3.08 4.72a12.39 12.39 0 0 1-4.8 2.73c-1.9.59-4 .89-6.34.89M77.87 14.62h9.06v24.74h14.16v7.94H77.87zM106.5 22.56h-9.81v-7.94h28.66v7.94h-9.8V47.3h-9.06zM129.41 14.62h9.1V47.3h-9.1z"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.secondary,"d":"M153.54 18.03h-10.98v-3.41h25.63v3.4h-10.97V47.3h-3.68zM172.25 14.62h22.05v3.31h-18.36v11.25h15.59v3.32h-15.6v11.48h18.32v3.32h-22zM228.44 14.62h3.68v14.52h18.86V14.62h3.7V47.3h-3.7V32.6h-18.86v14.7h-3.69z"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.primary,"d":"M292 .84a30.15 30.15 0 0 0-30.12 30.12A30.15 30.15 0 0 0 292 61.08a30.15 30.15 0 0 0 30.11-30.12c0-16.6-13.5-30.12-30.1-30.12m0 50.3a20.2 20.2 0 0 1-20.2-20.18 20.2 20.2 0 0 1 20.2-20.18 20.2 20.2 0 0 1 20.17 20.18A20.2 20.2 0 0 1 292 51.14"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.innerRing,"d":"M292 51.14a20.2 20.2 0 0 1-20.19-20.18 20.2 20.2 0 0 1 20.2-20.18 20.2 20.2 0 0 1 20.17 20.18A20.2 20.2 0 0 1 292 51.14"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.secondary,"d":"M308.87 30.96a16.87 16.87 0 1 0-33.74 0 16.87 16.87 0 0 0 33.74 0"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.secondary,"d":"M221.88 40.38a12.9 12.9 0 0 1-9.42 4.14c-4.08 0-7.74-1.93-10.15-4.94-1.88-2.35-3-5.35-3-8.62 0-3.27 1.12-6.28 3-8.62a12.99 12.99 0 0 1 10.15-4.94c3.7 0 7.03 1.59 9.42 4.13l2.5-2.5a16.87 16.87 0 1 0 0 23.86l-2.5-2.5zM259.63 19.57a2.64 2.64 0 0 1-1.9-.8 2.72 2.72 0 0 1-.8-1.88 2.6 2.6 0 0 1 .8-1.91 2.7 2.7 0 0 1 4.38.85c.14.32.2.67.2 1.04a2.62 2.62 0 0 1-.78 1.91 2.7 2.7 0 0 1-1.9.79m0-4.81a2.06 2.06 0 0 0-1.5.62 2.06 2.06 0 0 0-.62 1.5 2.08 2.08 0 0 0 .62 1.5 2.1 2.1 0 0 0 2.32.45 2.11 2.11 0 0 0 1.13-2.78 2.15 2.15 0 0 0-1.13-1.13c-.26-.1-.53-.16-.82-.16m1.56 3.52h-.74l-.8-1.05h-.54v1.05h-.6v-2.94h1.27c.37 0 .66.1.87.3.16.17.25.38.25.62 0 .3-.1.52-.3.68-.08.08-.18.14-.3.18l.9 1.16zm-2.08-1.63h.65c.19 0 .33-.04.43-.11a.3.3 0 0 0 .12-.26c0-.12-.03-.2-.11-.26-.1-.07-.24-.1-.44-.1h-.65v.73z"}})])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./src/components/LogoMultitech.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  LogoMultitech,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_LogoMultitech = (Component.exports);

// EXTERNAL MODULE: ./src/components/RouteTransition.vue + 2 modules
var RouteTransition = __webpack_require__(1234);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LogoLens.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LogoLens = ({
  name: 'LogoLens'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60694624","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoLens.vue
var LogoLens_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"343.31 287.7 106.1 37.36"}},[_c('title',[_vm._v("LENS")]),_vm._v(" "),_c('g',{attrs:{"fill":"#FFF"}},[_c('path',{attrs:{"d":"M375.04 297.07v18.66h13.1v-2.99h-9.82v-15.67zM403.77 300v-2.93h-13.83v18.66h13.97v-2.93h-10.69v-5.01h9.35v-2.93h-9.35V300zM432.25 289.22H418.7a2.73 2.73 0 1 0 0 2.42h13.55c8.13 0 14.75 6.61 14.75 14.74s-6.62 14.75-14.75 14.75h-9.27l-17.07-24.05v18.65h3.22v-9.43l12.36 17.24h10.76c9.47 0 17.16-7.7 17.16-17.16s-7.7-17.16-17.16-17.16z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M411.86 319.6c-1.07 0-2 .63-2.44 1.53h-48.94c-8.13 0-14.75-6.5-14.75-14.5s6.62-14.5 14.75-14.5h44.94l16.77 23.6v-18.65h-3.22v9.11l-11.8-16.49h-46.69c-9.46 0-17.17 7.6-17.17 16.92 0 9.33 7.7 16.92 17.17 16.92h48.93a2.73 2.73 0 1 0 2.45-3.93z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M370.77 307.07h-4.23c-.04 1.1-.2 2.17-.47 3.21a1.52 1.52 0 0 1 .64 1.4c.7.33 1.38.72 2.04 1.16a10.48 10.48 0 0 0 2.02-5.77zM360.69 310.22c1.09.04 2.18.19 3.25.46.27-.4.73-.67 1.26-.67h.02c.25-.96.4-1.94.43-2.94h-1.02a1.52 1.52 0 0 1-2.91 0h-1.03v3.15zM360.69 317.15l.17-.16a14.81 14.81 0 0 0 3.34-4.32 1.52 1.52 0 0 1-.52-1.14c-.98-.24-1.99-.38-3-.41v6.03zM362.15 296.26a15.28 15.28 0 0 1 3.3 4.88c.52-.2 1.03-.44 1.53-.71-.15-.54 0-1.13.43-1.53a10.48 10.48 0 0 0-5.26-2.64zM360.86 296.26l-.18-.16v6.03a14.2 14.2 0 0 0 3.93-.68 14.6 14.6 0 0 0-3.75-5.2zM360.69 306.18h1.03a1.52 1.52 0 0 1 2.9 0h1.02a13.25 13.25 0 0 0-.71-3.9c-1.38.45-2.81.7-4.25.74v3.16zM368.19 313.54c-.6-.4-1.2-.74-1.83-1.04a1.52 1.52 0 0 1-1.34.54 15.54 15.54 0 0 1-2.86 3.95c2.38-.44 4.49-1.69 6.02-3.45zM359.61 316.99l.18.16v-6.03c-1.33.04-2.65.27-3.92.68.8 1.92 2.07 3.7 3.74 5.19zM369.31 301.26c-.56.4-1.31.35-1.83-.08-.56.3-1.13.57-1.71.8.47 1.35.72 2.75.77 4.2h4.23c-.07-1.8-.6-3.47-1.46-4.92zM359.8 307.07h-4.97c.04 1.34.29 2.65.71 3.9 1.39-.46 2.82-.7 4.25-.75v-3.15zM359.8 296.1l-.19.16a14.75 14.75 0 0 0-3.34 4.31c.32.28.52.69.53 1.14.98.25 1.98.39 2.99.42v-6.03zM359.8 303.02c-1.1-.03-2.2-.18-3.26-.45-.28.4-.74.67-1.26.67h-.02c-.25.95-.4 1.94-.43 2.94h4.96v-3.16zM349.7 306.18h4.24c.03-1.1.19-2.17.47-3.22a1.52 1.52 0 0 1-.64-1.38 15.2 15.2 0 0 1-2.04-1.18 10.47 10.47 0 0 0-2.03 5.78zM355.28 300.2l.17.01a15.44 15.44 0 0 1 2.87-3.95c-2.39.43-4.5 1.68-6.03 3.44.59.4 1.2.75 1.82 1.05.28-.34.7-.55 1.17-.55zM358.32 316.99a15.22 15.22 0 0 1-3.3-4.89c-.52.2-1.03.44-1.53.71.15.54 0 1.14-.42 1.53a10.48 10.48 0 0 0 5.25 2.65zM351.16 311.99c.57-.4 1.32-.36 1.84.08.55-.31 1.12-.57 1.7-.8a14.1 14.1 0 0 1-.76-4.2h-4.24c.08 1.79.6 3.47 1.46 4.92zM430.97 299.71c1.7 0 3.39.67 5.06 1.92.44.31.83.64 1.2.97v-3.86a12.1 12.1 0 0 0-6.2-1.93c-3.7 0-6.37 2.21-6.37 5.4v.06c0 3.44 2.23 4.61 6.2 5.57 3.47.8 4.22 1.52 4.22 2.85v.06c0 1.38-1.28 2.34-3.3 2.34-2.3 0-4.11-.88-5.9-2.42-.41-.36-.78-.73-1.12-1.1v4.14a11.44 11.44 0 0 0 6.93 2.29c3.92 0 6.67-2.08 6.67-5.57v-.05c0-3.1-2.03-4.5-5.97-5.47-3.6-.85-4.46-1.49-4.46-2.93v-.05c0-1.23 1.12-2.22 3.04-2.22z"}})])])}
var LogoLens_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/LogoLens.vue
/* script */


/* template */

/* template functional */
var LogoLens___vue_template_functional__ = false
/* styles */
var LogoLens___vue_styles__ = null
/* scopeId */
var LogoLens___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LogoLens___vue_module_identifier__ = null

var LogoLens_Component = Object(component_normalizer["a" /* default */])(
  LogoLens,
  LogoLens_render,
  LogoLens_staticRenderFns,
  LogoLens___vue_template_functional__,
  LogoLens___vue_styles__,
  LogoLens___vue_scopeId__,
  LogoLens___vue_module_identifier__
)

/* harmony default export */ var components_LogoLens = (LogoLens_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(7);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/p-debounce/index.js
var p_debounce = __webpack_require__(1421);
var p_debounce_default = /*#__PURE__*/__webpack_require__.n(p_debounce);

// EXTERNAL MODULE: ./node_modules/p-queue/index.js
var p_queue = __webpack_require__(1422);
var p_queue_default = /*#__PURE__*/__webpack_require__.n(p_queue);

// EXTERNAL MODULE: ./src/store/notifications.js
var notifications = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Search.vue
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var queue = new p_queue_default.a({ concurrency: 1 });

var ResultLink = {
  props: {
    item: Object,
    routeKey: String
  },
  template: '\n    <router-link\n      :to="\'/\'+routeKey+\'/\' + item.eui"\n      class="result-link block text-decoration-none black-text"\n      tabindex="0"\n      >\n      <v-layout>\n        <span style="flex-basis: 180px; flex-shrink: 0;">{{item.eui}}</span>\n        <span class="medium">{{item.name}}</span>\n      </v-layout>\n    </router-link>\n  '
};

/* harmony default export */ var Search = ({
  name: 'Search',
  data: function data() {
    return {
      query: '',
      results: {
        applicationNetworks: [],
        gateways: [],
        endDevices: []
      },
      queue: queue
    };
  },

  computed: {
    isLoading: function isLoading() {
      return !!this.queue.pending;
    },
    noResults: function noResults() {
      var results = this.results;

      return !results.applicationNetworks.length && !results.gateways.length && !results.endDevices.length;
    }
  },
  methods: {
    reset: function reset() {
      window.document.activeElement.blur();
      this.query = '';
      this.results.applicationNetworks = [];
      this.results.gateways = [];
      this.results.endDevices = [];
    },

    handleInput: p_debounce_default()(function () {
      queue.add(this.fetchResults);
    }, 200),
    getSelectedResult: function getSelectedResult() {
      return document.querySelector('.selected-result');
    },
    getResultLinks: function getResultLinks() {
      if (!this.$refs.results) return [];
      return this.$refs.results.$el.getElementsByTagName('a');
    },
    selectFirstItem: function selectFirstItem() {
      var links = this.getResultLinks();
      links[0] && links[0].classList.add('selected-result');
    },
    handleDownArrow: function handleDownArrow() {
      var links = this.getResultLinks();
      var selected = this.getSelectedResult();
      // Default is first result
      var nextSelection = links[0];

      for (var i = 0; i < links.length; i++) {
        if (links[i] === selected) {
          if (i + 1 === links.length) {
            nextSelection = links[0];
          } else {
            nextSelection = links[i + 1];
          }
          break;
        }
      }
      this.removeSelection();
      nextSelection && nextSelection.classList.add('selected-result');
    },
    handleUpArrow: function handleUpArrow() {
      var links = this.getResultLinks();
      var selected = this.getSelectedResult();
      // Default is the last result
      var nextSelection = links[links.length - 1];

      for (var i = 0; i < links.length; i++) {
        if (links[i] === selected) {
          if (i === 0) {
            nextSelection = links[links.length - 1];
          } else {
            nextSelection = links[i - 1];
          }
          break;
        }
      }
      this.removeSelection();
      nextSelection && nextSelection.classList.add('selected-result');
    },
    handleEnter: function handleEnter() {
      var selected = this.getSelectedResult();
      selected && selected.click();
    },
    removeSelection: function removeSelection() {
      var selected = this.getSelectedResult();
      selected && selected.classList.remove('selected-result');
    },
    fetchResults: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _ref2, meta;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios_default.a.get('/search?q=' + this.query);

              case 3:
                _ref2 = _context.sent;
                meta = _ref2.data.meta;

                this.results.applicationNetworks = meta.application_networks || [];
                this.results.gateways = meta.gateways || [];
                this.results.endDevices = meta.end_devices || [];
                // Wait until component is rerendered
                _context.next = 10;
                return this.$nextTick();

              case 10:
                this.selectFirstItem();
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](0);

                this.$store.dispatch(notifications["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load search results.',
                  detail: _context.t0.message,
                  color: 'error'
                });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 13]]);
      }));

      function fetchResults() {
        return _ref.apply(this, arguments);
      }

      return fetchResults;
    }()
  },
  components: {
    ResultLink: ResultLink
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a83dc99","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
var Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('v-text-field',{staticClass:"search-input",attrs:{"name":"search","label":"Jump to...","append-icon-cb":_vm.reset,"single-line":"","prepend-icon":"search","clearable":""},on:{"input":_vm.handleInput,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.reset.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter.apply(null, arguments)}],"keypress":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.handleDownArrow.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.handleUpArrow.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }return _vm.removeSelection.apply(null, arguments)}]},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}}),_vm._v(" "),(_vm.query)?_c('v-card',{ref:"results",staticClass:"absolute right-0 elevation-10",staticStyle:{"top":"45px","width":"500px","border":"1px solid #cfd3d6"},attrs:{"light":""},on:{"mouseover":_vm.removeSelection}},[(_vm.results.applicationNetworks.length)?_c('div',{staticClass:"pb1"},[_c('h1',{staticClass:"title bg-light-gray p2 mb1"},[_vm._v("\n          Application Networks\n        ")]),_vm._v(" "),_vm._l((_vm.results.applicationNetworks),function(item){return _c('ResultLink',{key:item.id,attrs:{"item":item,"routeKey":"application-networks"},nativeOn:{"click":function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.reset.apply(null, arguments)}}})})],2):_vm._e(),_vm._v(" "),(_vm.results.gateways.length)?_c('div',{staticClass:"pb1"},[_c('h1',{staticClass:"title bg-light-gray p2 mb1"},[_vm._v("\n          Gateways\n        ")]),_vm._v(" "),_vm._l((_vm.results.gateways),function(item){return _c('ResultLink',{key:item.id,attrs:{"item":item,"routeKey":"gateways"},nativeOn:{"click":function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.reset.apply(null, arguments)}}})})],2):_vm._e(),_vm._v(" "),(_vm.results.endDevices.length)?_c('div',{staticClass:"pb1"},[_c('h1',{staticClass:"title bg-light-gray p2 mb1"},[_vm._v("\n          End-devices\n        ")]),_vm._v(" "),_vm._l((_vm.results.endDevices),function(item){return _c('ResultLink',{key:item.id,attrs:{"item":item,"routeKey":"end-devices"},nativeOn:{"click":function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.reset.apply(null, arguments)}}})})],2):_vm._e(),_vm._v(" "),(_vm.noResults)?_c('p',{staticClass:"italic px2 no-results"},[_vm._v("\n      No results\n    ")]):_vm._e(),_vm._v(" "),_c('v-progress-linear',{staticClass:"m0",attrs:{"active":_vm.isLoading,"indeterminate":true,"height":"3"}})],1):_vm._e()],1)}
var Search_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/Search.vue
function injectStyle (context) {
  __webpack_require__(1417)
  __webpack_require__(1419)
}
/* script */


/* template */

/* template functional */
var Search___vue_template_functional__ = false
/* styles */
var Search___vue_styles__ = injectStyle
/* scopeId */
var Search___vue_scopeId__ = "data-v-4a83dc99"
/* moduleIdentifier (server only) */
var Search___vue_module_identifier__ = null

var Search_Component = Object(component_normalizer["a" /* default */])(
  Search,
  Search_render,
  Search_staticRenderFns,
  Search___vue_template_functional__,
  Search___vue_styles__,
  Search___vue_scopeId__,
  Search___vue_module_identifier__
)

/* harmony default export */ var components_Search = (Search_Component.exports);

// EXTERNAL MODULE: ./src/utils/api.js
var api = __webpack_require__(18);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Topbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Topbar = ({
  name: 'Topbar',
  extends: {
    computed: {
      sysAdmin: api["j" /* sysAdmin */],
      orgAdmin: api["d" /* orgAdmin */]
    }
  },
  props: {
    routePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    organizationName: function organizationName() {
      return this.$store.getters.currentOrganization.name;
    },
    shouldRenderBackButton: function shouldRenderBackButton() {
      var pathArray = this.routePath.split('/');
      if (pathArray.length > 2 && pathArray[2] !== 'new') {
        return true;
      }
      return false;
    }
  },
  components: {
    LogoLens: components_LogoLens,
    Search: components_Search
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6591cfe0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
var Topbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"bg-dark",class:[{pr1: _vm.$mq.md_sm, relative: !_vm.$mq.md}],attrs:{"app":"","text":"","dark":"","clipped-left":""}},[_c('div',{staticClass:"circuit-background absolute bottom-0 m0",staticStyle:{"left":"0px"}}),_vm._v(" "),_c('div',{staticClass:"flex",staticStyle:{"max-width":"250px"}},[_c('LogoLens',{staticClass:"fit",staticStyle:{"margin-left":"10px","height":"28px"}})],1),_vm._v(" "),_c('transition-group',{staticClass:"flex align-center toolbar-transition-group pl2",attrs:{"name":"slide-x-transition"}},[(_vm.shouldRenderBackButton)?_c('v-btn',{key:"button",staticStyle:{"margin-left":"-4px"},attrs:{"icon":"","ripple":false},on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{key:"title",class:_vm.$mq.md_sm ? 'ml1' : 'ml0'},[_c('div',{},[(_vm.sysAdmin)?_c('span',{staticClass:"sys_admin role"},[_vm._v("[System Admin] ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.organizationName)+"\n    ")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$mq.md_sm)?_c('Search'):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var Topbar_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/Topbar.vue
function Topbar_injectStyle (context) {
  __webpack_require__(1415)
}
/* script */


/* template */

/* template functional */
var Topbar___vue_template_functional__ = false
/* styles */
var Topbar___vue_styles__ = Topbar_injectStyle
/* scopeId */
var Topbar___vue_scopeId__ = "data-v-6591cfe0"
/* moduleIdentifier (server only) */
var Topbar___vue_module_identifier__ = null

var Topbar_Component = Object(component_normalizer["a" /* default */])(
  Topbar,
  Topbar_render,
  Topbar_staticRenderFns,
  Topbar___vue_template_functional__,
  Topbar___vue_styles__,
  Topbar___vue_scopeId__,
  Topbar___vue_module_identifier__
)

/* harmony default export */ var components_Topbar = (Topbar_Component.exports);

// EXTERNAL MODULE: ./src/icons.js
var icons = __webpack_require__(710);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SlideSidebarMenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var SlideSidebarMenu = ({
  extends: {
    methods: {
      sysAdmin: api["j" /* sysAdmin */],
      sysRo: api["k" /* sysRo */]
    }
  },
  data: function data() {
    return {
      icons: icons["a" /* default */],
      networkitems: [{
        title: 'Application Networks',
        link: '/#/application-networks',
        icon: 'device_hub'
      }, {
        title: 'Gateways',
        link: '/#/gateways',
        icon: 'router'
      }, {
        title: 'Policies',
        link: '/#/policies',
        icon: 'lock'
      }, {
        title: 'Network Profiles',
        link: '/#/application-networks/profiles',
        icon: 'assignment'
      }],
      deviceitems: [{
        title: 'End-Devices',
        link: '/#/end-devices',
        icon: 'radio_button_on'
      }, {
        title: 'Device Groups',
        link: '/#/end-devices/groups',
        icon: 'select_all'
      }, {
        title: 'Operations',
        link: '/#/operations',
        icon: 'settings_remote'
      }, {
        title: 'Device Profiles',
        link: '/#/end-devices/profiles',
        icon: 'assignment'
      }],
      useritems: [{
        title: 'Organization',
        link: '', // See watch and mount operations below
        icon: 'business'
      }, {
        title: 'Activity',
        link: '', // See watch and mount operations below
        icon: 'toc'
      }, {
        title: 'License',
        link: '', // See watch and mount operations below
        icon: 'folder'
      }, {
        title: 'Broadcast',
        link: '', // See watch and mount operations below
        icon: 'email'
      }, {
        title: 'People',
        link: '/#/people',
        icon: 'supervisor_account'
      }, {
        title: 'Profile',
        link: '/#/me',
        icon: 'account_circle'
      }, {
        title: 'Support',
        link: '/#/support',
        icon: 'help_outline'
      }],
      devicehqitems: [{
        title: 'DeviceHQ',
        link: '/#/devicehq/login',
        icon: 'account_balance'
      }, {
        title: 'Account',
        link: '/#/devicehq/account',
        icon: 'account_circle'
      }, {
        title: 'Users',
        link: '/#/devicehq/users',
        icon: 'supervisor_account'
      }, {
        title: 'Devices',
        link: '/#/devicehq/devices',
        icon: 'radio_button_on'
      }, {
        title: 'Dev View',
        link: '/#/devicehq/device',
        icon: 'radio_button_on'
      }],
      systemitems: [{
        title: 'Organizations',
        link: '/#/organizations',
        icon: 'group_work'
      }],
      adminOnlyItems: [{
        title: 'Dashboard',
        link: '/#/dashboard',
        icon: 'dashboard'
      }, {
        title: 'Service Api Keys',
        link: '/#/service-api-keys',
        icon: icons["a" /* default */].serviceApiKeyIcon
      }, {
        title: 'Settings',
        link: '/#/systemlimits',
        icon: 'settings'
      }, {
        title: 'Services',
        link: '/#/vaults',
        icon: 'lock',
        oldTag: "vaultitem"
      }, {
        title: 'Broadcast',
        link: '/#/systembroadcast',
        icon: 'email',
        oldTag: "systembroadcastitem"
      }]
    };
  },
  components: {
    LogoMultitech: components_LogoMultitech
  },
  computed: {
    currentUserOrganizationPath: function currentUserOrganizationPath() {
      return '/#/my_organization/' + this.$store.getters.currentOrganization.id;
    }
  },
  mounted: function mounted() {
    this.useritems[0].link = this.currentUserOrganizationPath;
    this.useritems[1].link = '/#/organization/' + this.$store.getters.currentOrganization.id;
    this.useritems[2].link = '/#/organization/' + this.$store.getters.currentOrganization.id + '/license';
    this.useritems[3].link = '/#/organization/' + this.$store.getters.currentOrganization.id + '/broadcasts';
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f365a6e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideSidebarMenu.vue
var SlideSidebarMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$mq.md)?_c('v-navigation-drawer',{staticClass:"bg-light-gray flex flex-column pb0",attrs:{"stateless":"","value":"true","app":"","fixed":"","permanent":"","clipped":"","mobile-break-point":"1024","width":"295"}},[_c('v-list',{attrs:{"expand":""}},[(_vm.sysAdmin() || _vm.sysRo())?_c('v-list-group',{attrs:{"prepend-icon":"security","no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v("System")])]},proxy:true}],null,false,2077156450)},[_vm._v(" "),_vm._l((_vm.adminOnlyItems),function(item,ix){return _c('v-list-item',{key:'admin-only-item-'+ix,attrs:{"href":item.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(item.icon)}})],1)],1)})],2):_c('v-list-item',{attrs:{"href":"/#/dashboard"}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("dashboard")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v("Dashboard")])],1),_vm._v(" "),_c('v-list-group',{attrs:{"prepend-icon":"device_hub","no-action":"","value":"true"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v("Network")])]},proxy:true}],null,false,2331439961)},[_vm._v(" "),_vm._l((_vm.networkitems),function(net,i){return _c('v-list-item',{key:i,attrs:{"href":net.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(net.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(net.icon)}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"prepend-icon":"radio_button_on","no-action":"","value":"true"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v("Device")])]},proxy:true}],null,false,3571619071)},[_vm._v(" "),_vm._l((_vm.deviceitems),function(ed,i){return _c('v-list-item',{key:i,attrs:{"href":ed.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(ed.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(ed.icon)}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"prepend-icon":"account_circle","no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-title',[_vm._v("User")])]},proxy:true}],null,false,3755385558)},[_vm._v(" "),_vm._l((_vm.systemitems),function(ed,i){return (_vm.sysAdmin() || _vm.sysRo())?_c('v-list-item',{key:'system-item-key'+i,attrs:{"href":ed.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(ed.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(ed.icon)}})],1)],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.useritems),function(ed,i){return _c('v-list-item',{key:i,attrs:{"href":ed.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(ed.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(ed.icon)}})],1)],1)})],2),_vm._v(" "),_c('v-list-item',{attrs:{"href":"/#/logout"}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v("Log Out")])],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('LogoMultitech',{staticClass:"ml2 mb2",staticStyle:{"width":"160px"}})],1):_c('v-toolbar',[_c('v-layout',{attrs:{"align-center":"","justify-space-around":""}},[_c('v-btn',{attrs:{"to":"/dashboard"}},[_c('v-icon',[_vm._v("dashboard")]),(_vm.$mq.md_sm)?_c('span',[_vm._v("Dashboard")]):_vm._e()],1),_vm._v(" "),_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({},on),[_c('v-icon',[_vm._v("device_hub")]),(_vm.$mq.md_sm)?_c('span',[_vm._v("Network")]):_vm._e()],1)]}}])},[_vm._v(" "),_c('v-list',_vm._l((_vm.networkitems),function(net,i){return _c('v-list-item',{key:i,attrs:{"href":net.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(net.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(net.icon)}})],1)],1)}),1)],1),_vm._v(" "),_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({},on),[_c('v-icon',[_vm._v("radio_button_on")]),(_vm.$mq.md_sm)?_c('span',[_vm._v("Device")]):_vm._e()],1)]}}])},[_vm._v(" "),_c('v-list',_vm._l((_vm.deviceitems),function(net,i){return _c('v-list-item',{key:i,attrs:{"href":net.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(net.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(net.icon)}})],1)],1)}),1)],1),_vm._v(" "),_c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({},on),[_c('v-icon',[_vm._v("account_circle")]),(_vm.$mq.md_sm)?_c('span',[_vm._v("User")]):_vm._e()],1)]}}])},[_vm._v(" "),_c('v-list',[(_vm.sysAdmin() || _vm.sysRo())?_c('v-list-item',{attrs:{"href":_vm.systemitem.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.systemitem.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(_vm.systemitem.icon)}})],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.useritems),function(net,i){return _c('v-list-item',{key:i,attrs:{"href":net.link}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(net.title)}}),_vm._v(" "),_c('v-list-item-action',[_c('v-icon',{domProps:{"textContent":_vm._s(net.icon)}})],1)],1)})],2)],1),_vm._v(" "),_c('v-btn',{attrs:{"to":"/logout"}},[_c('v-icon',[_vm._v("exit_to_app")]),(_vm.$mq.md_sm)?_c('span',[_vm._v("Log Out")]):_vm._e()],1)],1)],1)],1)}
var SlideSidebarMenu_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/SlideSidebarMenu.vue
function SlideSidebarMenu_injectStyle (context) {
  __webpack_require__(1423)
}
/* script */


/* template */

/* template functional */
var SlideSidebarMenu___vue_template_functional__ = false
/* styles */
var SlideSidebarMenu___vue_styles__ = SlideSidebarMenu_injectStyle
/* scopeId */
var SlideSidebarMenu___vue_scopeId__ = "data-v-4f365a6e"
/* moduleIdentifier (server only) */
var SlideSidebarMenu___vue_module_identifier__ = null

var SlideSidebarMenu_Component = Object(component_normalizer["a" /* default */])(
  SlideSidebarMenu,
  SlideSidebarMenu_render,
  SlideSidebarMenu_staticRenderFns,
  SlideSidebarMenu___vue_template_functional__,
  SlideSidebarMenu___vue_styles__,
  SlideSidebarMenu___vue_scopeId__,
  SlideSidebarMenu___vue_module_identifier__
)

/* harmony default export */ var components_SlideSidebarMenu = (SlideSidebarMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MenuList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var MenuHLink = {
  props: ['icon', 'text', 'to', 'exact'],
  template: '\n    <router-link\n      :to="to"\n      class="menu-h-link flex flex-none flex-column items-center black-text text-decoration-none"\n      :exact="exact"\n      style="padding: 8px; margin: -8px;"\n    >\n      <v-icon >{{icon}}</v-icon>\n      <span v-if="$mq.md_sm">{{text}}</span>\n    </router-link>\n  ',
  created: function created() {
    if (false) {
      this.$mq = this.$parent.$mq;
    }
  }
};

var MenuVLink = {
  props: {
    icon: String,
    text: String,
    to: String,
    exact: Boolean,
    subMenu: Boolean
  },
  template: '\n  <v-list-tile :to="to" class="menu-v-link" :class="{subMenu: subMenu}" :exact="exact">\n      <v-list-tile-action>\n        <v-icon>{{icon}}</v-icon>\n      </v-list-tile-action>\n      <v-list-tile-content>\n      <v-list-tile-title class="menu-v-title" >\n          {{text}}\n        </v-list-tile-title>\n      </v-list-tile-content>\n    </v-list-tile>\n  '
};

/* harmony default export */ var MenuList = ({
  extends: {
    computed: {
      sysAdmin: api["j" /* sysAdmin */],
      orgAdmin: api["d" /* orgAdmin */]
    }
  },
  name: 'MenuList',
  props: {
    horizontal: Boolean,
    vertical: {
      type: Boolean,
      default: true
    },
    group: String
  },
  data: function data() {
    return Object.assign({}, icons["a" /* default */]);
  },

  computed: {
    currentUserOrganizationPath: function currentUserOrganizationPath() {
      return '/my_organization/' + this.$store.getters.currentOrganization.id;
    }
  },
  components: {
    MenuVLink: MenuVLink,
    MenuHLink: MenuHLink
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dfcc2476","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuList.vue
var MenuList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.horizontal)?_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('menu-h-link',{staticStyle:{"margin-left":"-10px"},attrs:{"to":"/dashboard","text":"Dashboard","icon":_vm.dashboardIcon}}),_vm._v(" "),_c('menu-h-link',{attrs:{"to":"/application-networks","text":"Application Networks","icon":_vm.applicationNetworksIcon}}),_vm._v(" "),_c('menu-h-link',{attrs:{"to":"/gateways","text":"Gateways","icon":_vm.gatewaysIcon}}),_vm._v(" "),_c('menu-h-link',{attrs:{"to":"/end-devices","text":"End-devices","icon":_vm.endDevicesIcon}}),_vm._v(" "),_c('menu-h-link',{attrs:{"to":"/people","text":"People","icon":_vm.peopleIcon}}),_vm._v(" "),_c('menu-h-link',{attrs:{"to":"/me","text":"Me","icon":_vm.myAccountIcon}}),_vm._v(" "),(!_vm.$mq.md_sm)?_vm._t("default"):[_c('menu-h-link',{attrs:{"to":"/operations","text":"Operations","icon":_vm.operationsIcon}}),_vm._v(" "),_c('menu-h-link',{attrs:{"to":"/support","text":"Support","icon":_vm.supportIcon}}),_vm._v(" "),_c('menu-h-link',{attrs:{"to":"/logout","text":"Log Out","icon":_vm.logOutIcon,"exact":""}})]],2):(_vm.vertical && _vm.group === '1')?_c('v-list',{staticClass:"pt-0"},[_c('menu-v-link',{attrs:{"to":"/dashboard","text":"Dashboard","icon":_vm.dashboardIcon}}),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/application-networks","text":"Application Networks","icon":_vm.applicationNetworksIcon}}),_vm._v(" "),(_vm.$route.path.includes('application-networks'))?_c('menu-v-link',{attrs:{"to":"/application-networks/profiles","text":"Profiles","subMenu":""}}):_vm._e(),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/gateways","text":"Gateways","icon":_vm.gatewaysIcon}}),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/end-devices","text":"End-devices","icon":_vm.endDevicesIcon}}),_vm._v(" "),(_vm.$route.path.includes('end-devices'))?_c('menu-v-link',{attrs:{"to":"/end-devices/profiles","text":"Profiles","subMenu":""}}):_vm._e(),_vm._v(" "),(_vm.$route.path.includes('end-devices'))?_c('menu-v-link',{attrs:{"to":"/end-devices/groups","text":"Groups","subMenu":""}}):_vm._e(),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/policies","text":"Policies","icon":_vm.policiesIcon}}),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/operations","text":"Operations","icon":_vm.operationsIcon}}),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/people","text":"People","icon":_vm.peopleIcon}}),_vm._v(" "),_c('menu-v-link',{attrs:{"to":{ path: '/service_api_keys' },"text":"Service Api Keys","icon":_vm.keyIcon}})],1):(_vm.vertical && _vm.group === '2')?_c('v-list',{staticClass:"pt-0"},[_c('menu-v-link',{attrs:{"to":"/me","text":"Me","icon":_vm.myAccountIcon}}),_vm._v(" "),(_vm.sysAdmin || _vm.orgAdmin)?_c('menu-v-link',{attrs:{"to":_vm.currentUserOrganizationPath,"text":"Organization","icon":_vm.orgIcon}}):_vm._e(),_vm._v(" "),(_vm.sysAdmin || _vm.sysRo)?_c('menu-v-link',{attrs:{"to":"/organizations","text":"Organizations","icon":_vm.orgsIcon}}):_vm._e(),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/support","text":"Support","icon":_vm.supportIcon}}),_vm._v(" "),_c('menu-v-link',{attrs:{"to":"/logout","text":"Log Out","icon":_vm.logOutIcon,"exact":""}})],1):_vm._e()}
var MenuList_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/MenuList.vue
function MenuList_injectStyle (context) {
  __webpack_require__(1429)
}
/* script */


/* template */

/* template functional */
var MenuList___vue_template_functional__ = false
/* styles */
var MenuList___vue_styles__ = MenuList_injectStyle
/* scopeId */
var MenuList___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MenuList___vue_module_identifier__ = null

var MenuList_Component = Object(component_normalizer["a" /* default */])(
  MenuList,
  MenuList_render,
  MenuList_staticRenderFns,
  MenuList___vue_template_functional__,
  MenuList___vue_styles__,
  MenuList___vue_scopeId__,
  MenuList___vue_module_identifier__
)

/* harmony default export */ var components_MenuList = (MenuList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TopbarMenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var TopbarMenu = ({
  name: 'TopbarMenu',
  data: function data() {
    return Object.assign({
      collapsed: true
    }, icons["a" /* default */]);
  },

  watch: {
    $route: function $route() {
      this.collapsed = true;
    }
  },
  components: {
    MenuList: components_MenuList
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abdc7f96","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopbarMenu.vue
var TopbarMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$mq.md_sm || _vm.collapsed)?_c('v-container',{staticClass:"bg-white",class:_vm.$mq.md_sm ? 'px3' : 'px2',attrs:{"fluid":""}},[_c('MenuList',{attrs:{"horizontal":""}},[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.collapsed = !_vm.collapsed}}},[_c('v-icon',[_vm._v("expand_more")])],1)])],1):_c('v-layout',{attrs:{"column":""}},[_c('button',{staticClass:"close-btn my0 absolute",on:{"click":function($event){$event.preventDefault();_vm.collapsed = !_vm.collapsed}}},[_c('v-icon',[_vm._v("expand_less")])],1),_vm._v(" "),_c('MenuList',{staticClass:"topbarmenu-list-override",attrs:{"vertical":"","group":"1"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('MenuList',{staticClass:"topbarmenu-list-override pb-0",attrs:{"vertical":"","group":"2"}})],1)}
var TopbarMenu_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/TopbarMenu.vue
function TopbarMenu_injectStyle (context) {
  __webpack_require__(1425)
  __webpack_require__(1427)
}
/* script */


/* template */

/* template functional */
var TopbarMenu___vue_template_functional__ = false
/* styles */
var TopbarMenu___vue_styles__ = TopbarMenu_injectStyle
/* scopeId */
var TopbarMenu___vue_scopeId__ = "data-v-abdc7f96"
/* moduleIdentifier (server only) */
var TopbarMenu___vue_module_identifier__ = null

var TopbarMenu_Component = Object(component_normalizer["a" /* default */])(
  TopbarMenu,
  TopbarMenu_render,
  TopbarMenu_staticRenderFns,
  TopbarMenu___vue_template_functional__,
  TopbarMenu___vue_styles__,
  TopbarMenu___vue_scopeId__,
  TopbarMenu___vue_module_identifier__
)

/* harmony default export */ var components_TopbarMenu = (TopbarMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NotificationSnackbar.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var NotificationSnackbar = ({
  name: 'NotificationSnackbar',
  data: function data() {
    return {
      snackbarVisible: false
    };
  },
  mounted: function mounted() {
    this.snackbarVisible = this.notificationToShow;
  },

  computed: {
    notification: function notification() {
      return this.$store.getters.nextNotification || {};
    },
    notificationToShow: function notificationToShow() {
      return this.$store.getters.notificationToShow;
    },
    timeout: function timeout() {
      if (typeof this.notification.timeout === 'number') {
        return this.notification.timeout;
      } else if (this.notification.color === 'error') {
        return 12000;
      } else {
        return 6000;
      }
    }
  },
  methods: {
    handleActionClick: function handleActionClick() {
      if (typeof this.notification.onClick === 'function') this.notification.onClick();
      this.snackbarVisible = false;
    },
    handleNotificationLinkClick: function handleNotificationLinkClick() {
      this.$router.push(this.notification.link[1]);
      this.snackbarVisible = false;
    }
  },
  watch: {
    notificationToShow: function notificationToShow(newValue) {
      // This shows snackbar if notification count goes from 0 to 1+
      if (newValue) {
        this.snackbarVisible = true;
      }
    },
    snackbarVisible: function snackbarVisible(newVal) {
      var _this = this;

      if (!newVal) {
        // Snackbar just closed
        if (this.notification) {
          this.$store.dispatch(notifications["b" /* REMOVE_NOTIFICATION */], { id: this.notification.id });
        }
        this.$nextTick(function () {
          // This shows next snackbar when more than one are queued
          if (_this.notificationToShow) {
            _this.snackbarVisible = true;
          }
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507dda25","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationSnackbar.vue
var NotificationSnackbar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{staticStyle:{"z-index":"1000"},attrs:{"top":"","color":_vm.notification.color,"multi-line":!!_vm.notification.detail,"timeout":_vm.timeout},model:{value:(_vm.snackbarVisible),callback:function ($$v) {_vm.snackbarVisible=$$v},expression:"snackbarVisible"}},[_c('div',{staticClass:"mr1"},[_vm._v("\n    "+_vm._s(_vm.notification.text)+"\n    "),(!!_vm.notification.detail)?_c('small',[(_vm.$mq.md_sm)?_c('br'):_vm._e(),_vm._v("\n      "+_vm._s(_vm.notification.detail)+"\n    ")]):_vm._e(),_vm._v(" "),(!!_vm.notification.link)?_c('small',[(_vm.$mq.md_sm)?_c('br'):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"m0",attrs:{"text":"","dark":""},on:{"click":_vm.handleNotificationLinkClick}},[_vm._v("\n        "+_vm._s(_vm.notification.link[0])+"\n      ")])],1):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.notification.showReloadButton)?_c('v-btn',{staticClass:"m0",attrs:{"text":"","dark":""},on:{"click":_vm.handleActionClick}},[_vm._v("\n    Reload\n  ")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"m0",attrs:{"text":"","dark":""},on:{"click":function($event){_vm.snackbarVisible = false}}},[_vm._v("\n    Dismiss\n  ")])],1)}
var NotificationSnackbar_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/NotificationSnackbar.vue
/* script */


/* template */

/* template functional */
var NotificationSnackbar___vue_template_functional__ = false
/* styles */
var NotificationSnackbar___vue_styles__ = null
/* scopeId */
var NotificationSnackbar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotificationSnackbar___vue_module_identifier__ = null

var NotificationSnackbar_Component = Object(component_normalizer["a" /* default */])(
  NotificationSnackbar,
  NotificationSnackbar_render,
  NotificationSnackbar_staticRenderFns,
  NotificationSnackbar___vue_template_functional__,
  NotificationSnackbar___vue_styles__,
  NotificationSnackbar___vue_scopeId__,
  NotificationSnackbar___vue_module_identifier__
)

/* harmony default export */ var components_NotificationSnackbar = (NotificationSnackbar_Component.exports);

// EXTERNAL MODULE: ./src/store/device_profiles.js
var device_profiles = __webpack_require__(236);

// EXTERNAL MODULE: ./src/store/network_profiles.js
var network_profiles = __webpack_require__(232);

// EXTERNAL MODULE: ./src/store/application_networks.js
var application_networks = __webpack_require__(231);

// EXTERNAL MODULE: ./src/store/users.js
var users = __webpack_require__(233);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import SidebarMenu from '@/components/SidebarMenu'











/* harmony default export */ var App = ({
  name: 'App',
  extends: {
    computed: {
      sysAdmin: api["j" /* sysAdmin */],
      orgAdmin: api["d" /* orgAdmin */],
      readOnlyUser: api["g" /* readOnlyUser */]
    }
  },
  mounted: function mounted() {
    // Always load these since almost every page needs it
    this.$store.dispatch(application_networks["d" /* FETCH_APPLICATION_NETWORKS */], {});
    this.$store.dispatch(users["c" /* FETCH_CURRENT_USER */]);
    this.$store.dispatch(device_profiles["d" /* FETCH_DEVICE_PROFILES */]);
    this.$store.dispatch(network_profiles["d" /* FETCH_NETWORK_PROFILES */]);
  },

  computed: {
    readOnlyUser: api["g" /* readOnlyUser */]
  },
  components: {
    RouteTransition: RouteTransition["a" /* default */],
    Sticky: sticky_default.a,
    Topbar: components_Topbar,
    // SidebarMenu,
    SlideSidebarMenu: components_SlideSidebarMenu,
    TopbarMenu: components_TopbarMenu,
    NotificationSnackbar: components_NotificationSnackbar,
    LogoMultitech: components_LogoMultitech
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492114f2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"flex flex-column flex-auto"},[_c('Topbar',{attrs:{"routePath":_vm.$route.path}},[_c('v-fab-transition',{attrs:{"appear":""}},[(!_vm.readOnlyUser)?_c('router-view',{attrs:{"name":"speeddial"}}):_vm._e()],1)],1),_vm._v(" "),_c('SlideSidebarMenu'),_vm._v(" "),_c('NotificationSnackbar'),_vm._v(" "),_c('v-content',{staticClass:"flex flex-column flex-auto",style:(_vm.$mq.md ? '' : 'padding-top: 5px;')},[(_vm.$mq.md)?_c('v-divider'):_vm._e(),_vm._v(" "),_c('v-container',{staticClass:"flex flex-column flex-auto",class:_vm.$mq.md_sm ? 'p3' : 'p2',attrs:{"fluid":""}},[_c('route-transition',[_c('router-view')],1)],1),_vm._v(" "),(!_vm.$mq.md_sm)?_c('v-layout',{staticClass:"circuit-background",attrs:{"justify-center":"","items-center":""}},[_c('LogoMultitech',{staticStyle:{"width":"100px"},attrs:{"white":""}})],1):_vm._e()],1)],1)}
var App_staticRenderFns = []

// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (context) {
  __webpack_require__(1410)
  __webpack_require__(1412)
}
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = "data-v-492114f2"
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null

var App_Component = Object(component_normalizer["a" /* default */])(
  App,
  App_render,
  App_staticRenderFns,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["default"] = (App_Component.exports);


/***/ }),

/***/ 710:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  dashboardIcon: 'dashboard',
  applicationNetworksIcon: 'device_hub',
  gatewaysIcon: 'router',
  endDevicesIcon: 'select_all',
  deviceProfilesIcon: 'assignment',
  networkProfilesIcon: 'assignment',
  operationsIcon: 'settings_remote',
  policiesIcon: 'lock',
  keyIcon: 'key-variant',
  serviceApiKeyIcon: 'mdi-folder-key-network',
  peopleIcon: 'supervisor_account',
  supportIcon: 'help_outline',
  orgIcon: 'business',
  orgsIcon: 'group_work',
  myAccountIcon: 'account_circle',
  logOutIcon: 'exit_to_app'
});

/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/circuit-board-background.8abdea14.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/78.d41ca29a.js